// import { useEffect, useState } from "react";

// import BreakingNews from "../../components/BreakingNews";
// import NewsCard from "../../components/NewsCard";
// import WebStories from "../../components/WebStories.jsx";
// import Profilecard from "../../components/Profilecard";

// import { getNewsByLanguage } from "../../api/apiHandler";

// import { latestStories, sidebarAd } from "../home/sidebarData";
// import {
//   topNews2,
//   topNews,
//   mpNews,
//   videonews,
//   webStories
// } from "../home/homeData";

// const Bundeli = () => {
//   const [bundeliNews, setBundeliNews] = useState([]);

//   // 🔹 NEW DYNAMIC DATA (ADMIN)
//   useEffect(() => {
//     getNewsByLanguage("bundeli")
//       .then((res) => {
//         setBundeliNews(res.data || []);
//       })
//       .catch(console.error);
//   }, []);

//   return (
//     <div className="max-w-7xl mx-auto -mt-[65px] px-4 py-6 sm:mt-[0px]">
//       <BreakingNews />

//       <div className="mt-2 grid grid-cols-1 lg:grid-cols-12 gap-6">

//         {/* ================= LEFT SIDE ================= */}
//         <div className="lg:col-span-9 space-y-12">

//           {/* 🔹 OLD STATIC TOP NEWS (UNCHANGED) */}
//           {topNews.slice(0, 4).map((item, i) => (
// <Profilecard key={item.id} data={item} />
//           ))}

//           {/* 🔹 NEW DYNAMIC BUNDELI NEWS */}
//           {bundeliNews.slice(0, 2).map((item) => (
//             <Profilecard key={`dynamic-${item.id}`} data={[item]} />
//           ))}

//           {/* 🔹 OLD STATIC GRID */}
//           <section>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {mpNews.slice(0, 2).map((item, i) => (
//                 <NewsCard key={`mp-${i}`} {...item} />
//               ))}
//             </div>
//           </section>

//           {/* 🔹 NEW DYNAMIC GRID */}
//           <section>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               {bundeliNews.slice(2, 5).map((item) => (
//                 <NewsCard key={item.id} {...item} />
//               ))}
//             </div>
//           </section>

//         </div>

//         {/* ================= RIGHT SIDE ================= */}
//         <aside className="lg:col-span-3">
//           <div className="sticky top-[120px]">

//             <div className="bg-white rounded-lg border shadow-sm overflow-hidden">

//               <div className="px-4 py-3 border-b">
//                 <h3 className="font-bold text-red-600 text-[18px] uppercase tracking-wide">
//                   Latest Stories
//                 </h3>
//               </div>

//               <div>
//                 {latestStories.map((item) => (
//                   <a
//                     key={item.id}
//                     href={item.link}
//                     className="flex gap-3 p-2 hover:bg-gray-50 transition group"
//                   >
//                     <img
//                       src={item.image}
//                       alt={item.title}
//                       className="w-20 h-14 object-cover rounded"
//                     />

//                     <p className="text-sm text-gray-800 font-medium leading-snug line-clamp-2 group-hover:text-red-600">
//                       {item.title}
//                     </p>
//                   </a>
//                 ))}
//               </div>

//               <div className="p-1">
//                 <a
//                   href={sidebarAd.link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="block"
//                 >
//                   <img
//                     src={sidebarAd.image}
//                     alt={sidebarAd.alt}
//                     className="w-full h-full object-contain bg-white rounded hover:opacity-95 transition"
//                   />
//                 </a>
//               </div>

//             </div>
//           </div>
//         </aside>

//       </div>
//     </div>
//   );
// };

// export default Bundeli;

import NewsPage from "../news/NewsPage";

const Bundeli = () => {
  return (
    <NewsPage language="bundeli" />
  );
};

export default Bundeli;
